import { getLinkToken } from 'app/models/linkLogin';
import { PATH_LINK_LOGIN } from 'app/router/routesConfigAuth';

const HANDOFF_KEY = 'linkLoginToken';

let pendingToken = null;

// El mismo criterio que la Route exact de Routes: sin distinguir mayúsculas y con una barra final opcional.
function isLinkLoginPath(pathname) {
  const path = pathname.toLowerCase();
  return path === PATH_LINK_LOGIN || path === `${PATH_LINK_LOGIN}/`;
}

function handOff(token) {
  try {
    if (token) {
      globalThis.sessionStorage.setItem(HANDOFF_KEY, token);
    } else {
      globalThis.sessionStorage.removeItem(HANDOFF_KEY);
    }
  } catch (error) {
    console.warn('Acceso por enlace: sin sessionStorage el enlace fallará como uno caducado', error.message);
  }
}

function receive() {
  try {
    const token = globalThis.sessionStorage.getItem(HANDOFF_KEY);
    globalThis.sessionStorage.removeItem(HANDOFF_KEY);
    return token;
  } catch (error) {
    console.warn('Acceso por enlace: no se pudo leer el token de sessionStorage', error.message);
    return null;
  }
}

/**
 * Lo primero de index.jsx. Con #token= en la URL, pasa el token por sessionStorage y recarga sin el
 * fragmento: replaceState no basta, Navigation Timing conserva la URL original y Sentry la enviaría.
 * Devuelve true mientras recarga: la app no debe arrancar.
 */
export function captureLinkToken() {
  const { pathname, search, hash } = globalThis.location;
  if (!isLinkLoginPath(pathname)) return false;

  if (hash) {
    handOff(getLinkToken(hash));
    globalThis.location.replace(`${pathname}${search}`);
    return true;
  }

  pendingToken = receive();
  return false;
}

export function takeLinkToken() {
  const token = pendingToken;
  pendingToken = null;
  return token;
}
